import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from './change-password.component';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordModalService {

  constructor(
    private modalService: NgbModal
  ) {
  }

  public open(modalOptions: Partial<NgbModalOptions> = {}): NgbModalRef {
    const modalRef = this.modalService.open(ChangePasswordComponent, {
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
      centered: true,
      ...modalOptions,
    });

    modalRef.componentInstance.modalReference = modalRef;

    return modalRef;
  }
}
